import { Box, Divider } from '@mui/material'
import { useStore } from '@priolo/jon'
import DateRangePickerH from 'components/controls/select/DateRangePickerH'
import SelectorCropsH from 'components/controls/select/SelectorCropsH'
import SelectorCycleH from 'components/controls/select/SelectorCycleH'
import SelectorGrowUnitH from 'components/controls/select/SelectorGrowUnitH'
import SelectorSessionH from 'components/controls/select/SelectorSessionH'
import FilterLockButton from 'components/header/FilterLockButton'
import React, { FunctionComponent, useMemo } from 'react'
import cycleSo from "stores/cycle"
import draftSo from 'stores/draft'
import { LastDateRange } from 'stores/planner/utils/fetch'
import querySo from 'stores/route/query'
import { queryFromNumberArray, queryToNumberArray } from 'stores/route/utils/query'
import { URL_PAR } from 'stores/route/utils/types'
import { Cycle } from 'types/Cycle'
import { GrowUnit } from 'types/GrowUnit'
import { DateRange } from 'types/global'
import { dateRangeToUrl, urlToDateRange } from 'utils'



interface Props {
	endRender?: React.ReactNode
}

const PlannerFilterHeader: FunctionComponent<Props> = ({
	endRender,
}) => {

	// STORE
	const querySa = useStore(querySo)
	const cycleSa = useStore(cycleSo)

	// HOOKs

	// HANDLERs
	const handleChangeDateRange = (dateRange: DateRange) => {
		querySo.setSearchUrl([URL_PAR.DATE_SEL, dateRangeToUrl(dateRange)])
	}
	const handleChangeGrowUnit = (growUnit: GrowUnit) => {
		querySo.setSearchUrl([URL_PAR.GROWUNIT_SEL, growUnit?.id?.toString()])
	}
	const handleChangeCrop = (cropIds: number[]) => {
		querySo.setSearchUrl([URL_PAR.CROP_SEL, cropIds?.length ? queryFromNumberArray(cropIds) : null])
	}

	const handleChangeCycle = (cycle: Cycle) => {
		querySo.setSearchUrl([URL_PAR.CYCLE_SEL, cycle?.cycleUuid])
	}

	// RENDER
	const [growUnitId, cropIds, cycle, dateRangeSel] = useMemo(() => {
		const [growUnitId, cropIdsUrl, cycleUuid, dateRangeSelUrl, colorsType] = querySo.getSearchUrl([URL_PAR.GROWUNIT_SEL, URL_PAR.CROP_SEL, URL_PAR.CYCLE_SEL, URL_PAR.DATE_SEL])
		let dateRangeSel = urlToDateRange(dateRangeSelUrl)
		const cycle = cycleSo.getCycleByUuid(cycleUuid)
		const cropIds = queryToNumberArray(cropIdsUrl)
		return [growUnitId, cropIds, cycle, dateRangeSel, colorsType]
	}, [querySa.queryUrl, cycleSa.all])
	const showCrop = !draftSo.isEditable()

	return (
		<Box sx={{ display: "flex", alignItems: "center", gap: 1}}>

			<FilterLockButton />

			<DateRangePickerH 
				dateRange={dateRangeSel}
				defaultDateRange={LastDateRange}
				onChange={handleChangeDateRange}
			/>

			<SelectorGrowUnitH
				growUnitId={+growUnitId}
				onChange={handleChangeGrowUnit}
			/>

			{showCrop &&
				<SelectorCropsH
					cropIds={cropIds}
					onChange={handleChangeCrop}
				/>
			}

			<SelectorCycleH 
				cycle={cycle}
				onChange={handleChangeCycle}
			/>

			<SelectorSessionH />

			<Divider orientation='vertical' flexItem sx={{  height: "24px" }} />

			{endRender}

		</Box >
	)
}

export default PlannerFilterHeader

